// export const ROOT_URL = 'http://localhost:8000/'
export const ROOT_URL = 'https://tsh-admin.ghiendecor.vn/'
